import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MarkdownIt from 'markdown-it';
import {
  Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EventBreadCrumb from './comp/report/EventBreadCrumb';
import HeaderEvent from './comp/report/HeaderEvent';
import ReportList from './comp/report/ReportList';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1000,
    margin: '0 auto',
    padding: theme.spacing(3),
  },

  eventCard: {
    padding: theme.spacing(3),
    borderRadius: 12,
    marginBottom: theme.spacing(4),
    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  },

  eventTitle: {
    fontSize: '1rem',
    fontWeight: 400,
    fontFamily: 'Kanit, sans-serif',
  },
  eventDate: {
    fontSize: '0.85rem',
    color: '#6b7280',
  },
  eventDesc: {
    fontSize: '0.9rem',
    color: '#444',
    lineHeight: 1.6,
    marginTop: theme.spacing(1),
    overflowWrap: 'anywhere',
  },

  reportCard: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: 6,
    border: '1px solid #eee',
  },

  reportTitle: {
    fontWeight: 600,
  },

  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontSize: 13,
    color: '#6b7280',
  },

  tagChip: {
    marginRight: 6,
    marginBottom: 6,
    height: 22,
    fontSize: 12,
  },

  statusDot: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: '15px',
    fontSize: 12,
    fontWeight: 600,
    gap: 6,
    '&::before': {
      content: '""',
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  },
  markdown: {
    wordBreak: 'break-word',

    '& img': {
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
      margin: '8px 0',
    },
  },
  attachmentItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 8px',
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    marginBottom: 8,
    textDecoration: 'none',
    color: '#111827',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#f9fafb',
      textDecoration: 'none',
    },
  },
  attachmentLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    overflow: 'hidden',
  },
  attachmentName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 320,
  },
  iconPdf: { color: '#dc2626' },
  iconImage: { color: '#10b981' },
  iconUrl: { color: '#62C5FF' },
  tagLabel: {
    fontSize: 13,
    fontWeight: 500,
  },
}));

const statusColorMap = {
  public: '#10b981',
};

const md = new MarkdownIt({
  html: true,
  linkify: true,
});
const initPath = `/${process.env.REACT_APP_PATH}`;
export default function ReportPage() {
  const classes = useStyles();

  const { eventId } = useParams();
  const [event, setEvent] = useState({});
  const [reports, setReports] = useState([]);

  useEffect(() => {
    const loadReports = async () => {
      const URL = `${process.env.REACT_APP_BACKOFFICE}/api/v1/public/reportwater/events/report/${eventId}`;
      const res = await fetch(URL);
      const json = await res.json();
      if (json.success) {
        setEvent(json.event);
        setReports(json.data || []);
      }
    };

    loadReports();
  }, [eventId]);

  return (
    <Box>
      <EventBreadCrumb
        initPath={initPath}
        event={event}
      />

      <HeaderEvent
        event={event}
        classes={classes}
        statusColorMap={statusColorMap}
        md={md}
      />

      <ReportList
        reports={reports}
        classes={classes}
        statusColorMap={statusColorMap}
        md={md}
      />
    </Box>
  );
}
